import { GameReelsProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameReelsProperties";
import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import { Point } from "pixi.js";
/**
 * ReelsPortraitProperties.ts
 */
export class ReelsPortraitProperties extends GameReelsProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scale.set(1);
        this.position = new Point(65, 1289);
        this.panelProperties.layout = new HorizontalLayout(7);
    }
    equals(other) {
        return false;
    }
}
